/**
 * Konkord: the WebKit engine: Safari on the Mac, and every browser on the
 * iPhone and the iPad (Chrome, Firefox and Edge there are Safari inside:
 * CriOS, FxiOS, EdgiOS). Nobody could test Konkord on it yet, so it isn't
 * listed as compatible (owner, 31/10). Only the user agent tells an engine
 * apart; everything else here checks the feature itself
 */
export function isWebKit(userAgent = globalThis.navigator?.userAgent ?? "") {
  return (
    /AppleWebKit/.test(userAgent) &&
    (/CriOS|FxiOS|EdgiOS/.test(userAgent) ||
      !/Chrome|Chromium|Edg|OPR|Firefox/.test(userAgent))
  );
}

/**
 * Konkord: screen capture (getDisplayMedia): the iPhone and the iPad only
 * have it from iOS 27, Android browsers not at all
 */
export function canShareScreen() {
  return (
    typeof globalThis.navigator?.mediaDevices?.getDisplayMedia === "function"
  );
}

/**
 * Konkord: full screen for a page element (the call): every computer browser
 * and the iPad have it, the iPhone doesn't
 */
export function canFullscreen() {
  const doc = globalThis.document;
  return (
    !!doc?.fullscreenEnabled &&
    typeof doc.documentElement?.requestFullscreen === "function"
  );
}
